(function () {
  function initLazyEmbeds(root) {
    var embeds = root.querySelectorAll('[data-lazy-embed-src]');
    if (!embeds.length) return;

    function load(iframe) {
      var src = iframe.getAttribute('data-lazy-embed-src');
      if (!src) return;
      iframe.src = src;
      iframe.removeAttribute('data-lazy-embed-src');
    }

    // Own IntersectionObserver instead of the browser's native loading="lazy"
    // heuristic - keeps the YouTube iframe's own JS/CSS bundle from
    // downloading until it's actually about to be seen.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          load(entry.target);
          io.unobserve(entry.target);
        });
      }, { rootMargin: '200px', threshold: 0.01 });
      embeds.forEach(function (iframe) {
        io.observe(iframe);
      });
    } else {
      embeds.forEach(load);
    }
  }

  document.querySelectorAll('.product-assembly-video').forEach(initLazyEmbeds);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.product-assembly-video');
    if (section) initLazyEmbeds(section);
  });

  function init(media) {
    var playBtn = media.querySelector('.product-assembly-video__play');
    var player = media.querySelector('.product-assembly-video__player');
    if (!playBtn || !player) return;

    var embedSrc = player.getAttribute('data-embed-src');

    playBtn.addEventListener('click', function () {
      media.classList.add('is-playing');
      player.classList.remove('hide');

      if (embedSrc) {
        var iframe = document.createElement('iframe');
        iframe.src = embedSrc;
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        player.appendChild(iframe);
      } else {
        player.play();
      }
    });
  }

  document.querySelectorAll('[data-product-assembly-video]').forEach(init);

  document.addEventListener('shopify:section:load', function (event) {
    var media = event.target.querySelector('[data-product-assembly-video]');
    if (media) init(media);
  });
})();
